import React from "react";
import CardLayout from "../../components/CardLayout";

const TicketHistoryPage = () => {
  return (
    <div className="mono_tickethistory_page_wrapper">
      <CardLayout
        style={{ backgroundColor: "#fff" }}
        className="mono_tickethistory_form_card"
      >
        <div className="mono_section_title">
          <h2>Support Ticket</h2>
        </div>
      </CardLayout>
    </div>
  );
};

export default TicketHistoryPage;
